import {Component, OnDestroy, OnInit} from '@angular/core';
import {MainRoute, RootRoute} from '../../../../shared/models/angular-routing';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangelogService} from '../../../../data/changelog/changelog.service';
import {Subscription} from 'rxjs';
import {Changelog} from '../../../../shared/models/changelog';
import {ToastService} from '../../../../shared/services/toast.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatHint } from '@angular/material/form-field';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  imports: [MatIconButton, MatIcon, MatProgressSpinner, MatHint, MarkdownComponent],
})
export class AboutComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private toastService: ToastService,
    protected changelogService: ChangelogService,
    private readonly route: ActivatedRoute
  ) {}

  applications = [
    { value: 'plowops', label: 'PlowOps' },
    { value: 'ios-release', label: 'iOS Mobile Application' },
    { value: 'android-release', label: 'Android Mobile Application' },
    { value: 'prohub', label: 'ProHub' },
  ];

  selectedApplication: { label: string; value: string };
  loading = false;
  changeLog?: Changelog | null;
  private queryParamsSubscription: Subscription;

  loadChangelog() {
    if (!this.selectedApplication) {
      return;
    }
    const app = this.selectedApplication.value;
    this.loading = true;
    this.changelogService
      .getChangelog(app)
      .then(response => {
        this.changeLog = new Changelog(app, response);
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        if (error.status === 404) {
          this.changeLog = new Changelog(app, '');
        } else {
          console.error('Error loading changelog', error);
          this.toastService.long('The changelog for selected application could not be loaded.');
          this.changeLog = null;
        }
      });
  }

  ngOnInit(): void {
    this.queryParamsSubscription = this.route.queryParams.subscribe(params => {
      this.selectedApplication = this.applications.find(app => app.value === params['application']) || this.applications[0];
      this.loadChangelog();
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

  selectApplication(app: string) {
    this.router
      .navigate([`/${RootRoute.MAIN}`, MainRoute.ABOUT], {
        queryParamsHandling: 'merge',
        queryParams: {
          application: app,
        },
      })
      .then();
  }

  close() {
    this.router
      .navigate([`/${RootRoute.MAIN}`], {
        queryParamsHandling: 'merge',
      })
      .then();
  }
}
